/**
 * RESPONSIBILITY: draw the 25th Anniversary band — words, timeline, video, one under another.
 *
 * Each part is drawn only when it has content, and the band is not drawn at all with
 * none: an anniversary band holding a grey placeholder and an empty video frame is a
 * page that looks broken, not one that is waiting (R18). The pencil stays, so whoever
 * fills it in can still find it.
 */
import { Html } from '@framework/react';
import { hasImage } from '@framework/core';
import type { AboutAnniversarySection } from '@app/sections';
import { Enlarge } from '../commons/Enlarge';
import { VideoPlayer } from '../commons/VideoPlayer';
import { YoutubeThumb } from '../commons/YoutubeThumb';

export function AboutAnniversary({ c }: { c: AboutAnniversarySection }) {
  const words = Boolean(c.eyebrow || c.heading || c.bodyHtml);
  const picture = hasImage(c.timeline);
  const video = Boolean(c.videoUrl?.trim());
  if (!words && !picture && !video) return null;

  return (
    <section className="band anniversary">
      <div className="wrap anniversary-stack">
        {words && (
          <div className="stack anniversary-words">
            {c.eyebrow && <p className="eyebrow">{c.eyebrow}</p>}
            {c.heading && <h2>{c.heading}</h2>}
            {c.bodyHtml && <Html className="md-body lede">{c.bodyHtml}</Html>}
          </div>
        )}
        {picture && <Enlarge value={c.timeline} className="anniversary-timeline" />}
        {video && (
          <VideoPlayer
            url={c.videoUrl} title={c.videoTitle || c.heading} className="video anniversary-video"
            picture={<YoutubeThumb url={c.videoUrl} alt={c.videoTitle || c.heading} className="video-pic" />}
          />
        )}
      </div>
    </section>
  );
}
